import { InformationVariantIcon } from './InformationVariantIcon';

/**
 * author: Simran
 * id D991D5FA-BD60-48E1-979D-A103D005725A
 * name information-variant
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-variant.svg
 * tags
 */
export const AboutVariantIcon = InformationVariantIcon;
export default AboutVariantIcon